import { Component } from "react";
import { Grid } from "@mui/material";
import { Unstable_Popup as BasePopup } from '@mui/base/Unstable_Popup';
import { evidence_explanation } from "../data/text";

class ReviewInfo extends Component {
    state = {
        isPopupOpen: false
    }

    constructor(props) {
        super(props);
        this.togglePopup = this.togglePopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
    }

    togglePopup() {
        this.setState({
            isPopupOpen: !this.state.isPopupOpen
        });
    }

    closePopup() {
        this.setState({
            isPopupOpen: false
        });
    }

    render() {
        const {isPopupOpen} = this.state;
        return (
            <Grid item xs={4}>
                <button
                    className="bbe-button"
                    onClick={this.togglePopup}>
                    <img src="https://img.icons8.com/nolan/64/info-squared.png" alt="info-squared" title={evidence_explanation}/>
                </button>
                <BasePopup open={isPopupOpen}>
                    <div className="form pop_up">
                        <Grid container alignItems="center" justifyContent="center" padding={3}> 
                            <Grid item xs={12} style={{ textAlign: 'center' }}>
                                <h2>Evidence Instructions</h2>
                                <p>Before the song can be shown on the app, evidence of ownership
                                     is required in the form of a screenshot. This can be:</p>
                                <ol>
                                    <li>Email of upload to distributor</li>
                                    <li>Spotify for artist page</li>
                                    <li>Email from Spotify for artist</li>
                                    <li>Another suitable image</li>
                                </ol>
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: 'center' }}>
                                <button
                                    className="bbe-button"
                                    onClick={this.closePopup}>
                                        <p>Close</p>
                                </button>
                            </Grid>    
                        </Grid>
                    </div>
                </BasePopup>
            </Grid>
        );
    }
}

export default ReviewInfo;